<template>
  <div class="middle-page-logout__root">
    <div class="icon"></div>
    <div class="label">账号已退出，请关闭后重新进入</div>
  </div>
</template>

<style lang="scss" scoped>
.middle-page-logout {
  &__root {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .icon {
      display: inline-block;
      background-image: url('@/assets/svg/white/icon-logout.svg');
      width: 100px;
      height: 100px;
    }

    .label {
      margin-top: 12px;
      height: 22px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: var(--lowcode-text-02);
      line-height: 22px;
    }
  }
}
</style>
